export const POST_LOGIN_REDIRECT_KEY = "monalu_post_login_redirect";

export function savePostLoginRedirect(path: string): void {
  try {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
  } catch {
    // ignore
  }
}

export function peekPostLoginRedirect(): string | null {
  try {
    return sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  } catch {
    return null;
  }
}

export function consumePostLoginRedirect(): string | null {
  const path = peekPostLoginRedirect();
  if (path) {
    try {
      sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    } catch {
      // ignore
    }
  }
  return path;
}

/** Redireciona após login se houver destino salvo e for diferente da URL atual. */
export function redirectAfterLoginIfNeeded(): boolean {
  const target = consumePostLoginRedirect();
  if (!target) return false;
  const current = `${window.location.pathname}${window.location.search}`;
  const normalizedTarget = target.replace(/\/+$/, "") || "/";
  const normalizedCurrent = current.replace(/\/+$/, "") || "/";
  if (normalizedTarget === normalizedCurrent) return false;
  window.location.href = target;
  return true;
}
